(function () {
  'use strict';

  var HASHES = {
    finder: 'cp-drink-finder',
    coffee: 'cp-coffee-match',
    usage: 'cp-usage-planner',
    cupboard: 'cp-cupboard-builder',
    setup: 'cp-home-setup-builder',
    water: 'cp-water-check'
  };

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function scrollToTool(node) {
    node.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }

  function invalidateResult(form, output, message, afterChange) {
    function changed() {
      delete output.dataset.shareText;
      output.hidden = false;
      output.textContent = message;
      if (afterChange) afterChange();
    }
    form.addEventListener('input', changed);
    form.addEventListener('change', changed);
    return changed;
  }

  function initResultRecovery(root) {
    ['finder', 'coffee', 'setup', 'water'].forEach(function (key) {
      var form = qs('[data-b2cx-' + key + ']', root), output = qs('[data-b2cx-' + key + '-result]', root);
      if (!form || !output) return;
      var changed = invalidateResult(form, output, root.dataset.resultChanged || 'Your choices changed. Run this tool again to see your current result.');
      root.addEventListener('cp:home-inputs-restored', function () {
        if (output.textContent.trim()) changed();
      });
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character];
    });
  }

  function safeNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : (fallback || 0);
  }

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function parseProducts(root) {
    try {
      var parsed = JSON.parse(qs('[data-cp-b2cx-products]', root).textContent || '[]');
      return Array.isArray(parsed) ? parsed.map(normaliseProduct).filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function parsePackFromTitle(title, subtype) {
    var source = String(title || '');
    if(/\bcase\b|\b\d+\s*[x×]\s*\d|\b\d+\s*(?:packs|bags|sachets)\s*(?:of|x|×)/i.test(source))return {value:0,unit:'',source:''};
    var weight = source.match(/(?:^|\s|[-–—(])(\d+(?:\.\d+)?)\s*(kg|g)(?:\b|\))/i);
    if (weight) {
      return {
        value: Number(weight[1]) * (weight[2].toLowerCase() === 'kg' ? 1000 : 1),
        unit: 'g',
        source: 'title'
      };
    }
    if (subtype === 'tea') {
      var count = source.match(/(?:^|\s|[-–—(])(\d{2,5})\s*(?:pack|tea\s*bags?|bags?)(?:\b|\))/i);
      if (count) return { value: Number(count[1]), unit: 'bag', source: 'title' };
    }
    return { value: 0, unit: '', source: '' };
  }

  function quantityUnit(value, unit) {
    unit=String(unit||'').toLowerCase().trim();value=safeNumber(value,0);
    if(['kg','kilogram','kilograms'].indexOf(unit)>-1)return {value:value*1000,unit:'g'};
    if(['g','gram','grams'].indexOf(unit)>-1)return {value:value,unit:'g'};
    if(['l','litre','litres'].indexOf(unit)>-1)return {value:value*1000,unit:'ml'};
    if(unit==='ml')return {value:value,unit:'ml'};
    if(['bag','bags','count','each'].indexOf(unit)>-1)return {value:value,unit:'bag'};
    return {value:0,unit:''};
  }
  function servingsFor(product, enteredDose) {
    var pack=quantityUnit(product.pack,product.packUnit),dose=quantityUnit(enteredDose,product.doseUnit||product.packUnit);
    if(enteredDose>0&&pack.value>0)return dose.value>0&&pack.unit===dose.unit?pack.value/dose.value:0;
    return product.servings>0?product.servings:0;
  }
  function householdExtra(product) {
    return product.category==='ingredient'||/(?:^|[ ,])cp-cupboard-extra(?:[ ,]|$)/.test(String(product.tags||''));
  }
  function normaliseProduct(product) {
    if (!product || !product.handle || !product.title || !product.url) return null;
    var subtype = String(product.subtype || '').toLowerCase();
    var pack = safeNumber(product.pack, 0);
    var packUnit = String(product.packUnit || '').toLowerCase();
    var packSource = pack > 0 ? 'metafield' : '';
    if (!pack) {
      var parsedPack = parsePackFromTitle(product.title, subtype);
      pack = parsedPack.value;
      packUnit = parsedPack.unit;
      packSource = parsedPack.source;
    }
    var canonical=quantityUnit(pack,packUnit);pack=canonical.value;packUnit=canonical.unit;
    var configuredDose = safeNumber(product.dose, 0);
    product.subtype = subtype;
    product.pack = pack;
    product.packUnit = packUnit;
    product.packSource = packSource;
    var doseMeasure=quantityUnit(configuredDose,product.doseUnit||product.packUnit);
    product.dose = doseMeasure.value;
    product.doseUnit = doseMeasure.unit||product.packUnit;
    product.doseSource = configuredDose ? 'metafield' : 'customer';
    product.servings = safeNumber(product.servings, 0);
    product.priceCents = safeNumber(product.priceCents, 0);
    return product;
  }

  function productText(product) {
    return [product.title, product.type, product.tags, product.description, product.profile, product.origin,
      product.milkSuitability, product.blackSuitability].join(' ').toLowerCase();
  }

  function productsBySubtype(products, subtypes) {
    if (!Array.isArray(subtypes)) subtypes = [subtypes];
    return products.filter(function (product) {
      return subtypes.indexOf(product.subtype) > -1 && (product.subtype!=='extras'||householdExtra(product));
    });
  }

  function firstAvailable(products, subtype) {
    var matches = productsBySubtype(products, subtype);
    return matches.find(function (product) { return product.available; }) || null;
  }

  function byHandle(products, handle) {
    return products.find(function (product) { return product.handle === handle; }) || null;
  }

  function shortText(value, maximumWords) {
    var words = String(value || '').trim().split(/\s+/).filter(Boolean);
    if (words.length <= maximumWords) return words.join(' ');
    return words.slice(0, maximumWords).join(' ') + '…';
  }

  function track(name, detail) {
    if (window.CPAnalytics && typeof window.CPAnalytics.track === 'function') {
      window.CPAnalytics.track(name, detail || {});
    }
  }

  function memory() {
    return window.CPStorefrontMemory || null;
  }

  function setStatus(root, message, link) {
    var status = qs('[data-b2cx-status]', root);
    if (!status) return;
    status.innerHTML = '<span>' + escapeHtml(message) + '</span>' + (link ? '<a href="' + escapeHtml(link.href) + '">' + escapeHtml(link.label) + '</a>' : '');
    status.classList.add('is-visible');
  }

  function saveProduct(root, product) {
    var store = memory();
    if (!store || !product) return false;
    var persisted = store.saveProduct(product);
    setStatus(root, persisted ? 'Saved on this device.' : 'Saved for this visit; browser storage is unavailable.');
    renderShelf(root);
    return persisted;
  }

  function tasteRow(label, value, low, high) {
    var rating = clamp(Math.round(safeNumber(value, 0)), 0, 5);
    if (!rating) return '';
    var dots = '';
    for (var index = 1; index <= 5; index += 1) {
      dots += '<i' + (index <= rating ? ' class="is-on"' : '') + '></i>';
    }
    return '<div class="cp-b2cx__taste-row" aria-label="' + escapeHtml(label + ': ' + rating + ' out of 5') + '"><span>' + escapeHtml(label) + '</span><small>' + escapeHtml(low) + '</small><b aria-hidden="true">' + dots + '</b><small>' + escapeHtml(high) + '</small></div>';
  }

  function tasteProfile(product) {
    var rows = [
      tasteRow('Body', product.body, 'Light', 'Full'),
      tasteRow('Acidity', product.acidity, 'Soft', 'Bright'),
      tasteRow('Roast', product.roast, 'Light', 'Dark'),
      tasteRow('Intensity', product.intensity, 'Gentle', 'Strong')
    ].filter(Boolean);
    var suitability = [];
    if (product.milkSuitability) suitability.push('<span>With milk: <strong>' + escapeHtml(product.milkSuitability) + '</strong></span>');
    if (product.blackSuitability) suitability.push('<span>Black: <strong>' + escapeHtml(product.blackSuitability) + '</strong></span>');
    if (!rows.length && !suitability.length) return '';
    return '<div class="cp-b2cx__taste">' + rows.join('') + (suitability.length ? '<div class="cp-b2cx__suitability">' + suitability.join('') + '</div>' : '') + '</div>';
  }

  function productCard(product, explanation, options) {
    options = options || {};
    if (!product) {
      return '<div class="cp-b2cx__no-match"><strong>No responsible product match is available.</strong><p>The current catalogue does not contain enough usable product data for this result.</p></div>';
    }
    var image = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" width="300" height="300" loading="lazy">' : '<span class="cp-b2cx__image-fallback" aria-hidden="true"></span>';
    var profile = explanation || shortText(product.profile || product.description, 34);
    var actions = '<a class="is-primary" href="' + escapeHtml(product.url) + '">View product</a>';
    if (product.available && product.variant) actions += '<button type="button" data-b2cx-add-handle="' + escapeHtml(product.handle) + '">Add to basket</button>';
    actions += '<button type="button" data-b2cx-save="' + escapeHtml(product.handle) + '">Save on this device</button>';
    if (options.share) actions += '<button type="button" data-b2cx-share-result>Share result</button>';
    return '<article class="cp-b2cx__result-card">' + image + '<div><p class="cp-b2cx__result-label">' + escapeHtml(options.label || 'Current product') + '</p><h4>' + escapeHtml(product.title) + '</h4><p>' + escapeHtml(profile) + '</p>' + tasteProfile(product) + '<div class="cp-b2cx__result-price">' + escapeHtml(product.price || '') + (product.available ? '' : ' · Currently unavailable') + '</div><div class="cp-b2cx__result-actions">' + actions + '</div></div></article>';
  }


  function collectionForSubtype(subtype) {
    return {
      instant: '/collections/instant-coffee-drinks',
      'coffee-beans': '/collections/coffee-beans-auto',
      chocolate: '/collections/hot-chocolate-auto',
      'white-chocolate': '/collections/hot-chocolate-auto',
      matcha: '/collections/matcha-tea-auto',
      tea: '/collections/tea',
      milk: '/collections/milk-powders-toppings',
      extras: '/collections/accessories'
    }[subtype] || '/collections/ingredients';
  }

  function formatCoverage(weeks) {
    if (!Number.isFinite(weeks) || weeks <= 0) return 'Check pack data';
    if (weeks < 1) return 'About ' + Math.max(1, Math.round(weeks * 7)) + ' days';
    if (weeks < 8) return 'About ' + weeks.toFixed(weeks < 3 ? 1 : 0) + ' weeks';
    var months = weeks / (52 / 12);
    return 'About ' + (months < 3 ? months.toFixed(1) : Math.round(months)) + ' months';
  }

  async function addItems(root, products, button, quantities) {
    var valid = products.map(function (product, index) {
      var quantity = quantities && quantities[index] ? Number(quantities[index]) : 1;
      return product && product.available && product.variant ? { id: String(product.variant), quantity: Math.max(1, Math.ceil(quantity || 1)), product: product } : null;
    }).filter(Boolean);
    if (!valid.length || valid.length !== products.length) {
      var needsReview = products.find(function (product) { return !product || !product.available || !product.variant; });
      setStatus(root, 'Nothing was added. Review the selected product’s options or availability first.', needsReview && needsReview.url ? { href: needsReview.url, label: 'Review product' } : null);
      return;
    }
    var original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    try {
      if (!window.CPCartBridge || typeof window.CPCartBridge.addItems !== 'function') throw new Error('Cart service is still loading.');
      var result = await window.CPCartBridge.addItems(valid, { activeElement: button || null, source: 'cp-b2c-experience' });
      result.added.forEach(function (item) {
        var store = memory();
        if (store && item.product) store.saveProduct(item.product);
      });
      var addedQty = result.added.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (result.failed.length) {
        if (button) button.textContent = 'Added ' + result.added.length + ' · check ' + result.failed.length;
        setStatus(root, 'Added ' + result.added.length + ' product' + (result.added.length === 1 ? '' : 's') + '. We could not confirm ' + result.failed.length + ' other addition' + (result.failed.length === 1 ? '' : 's') + '. Check your basket before adding anything again.', { href: root.dataset.cartUrl || '/cart', label: 'Check basket' });
      } else {
        if (button) button.textContent = 'Added to basket ✓';
        setStatus(root, result.added.length === 1 ? 'Added to your basket.' : 'Added ' + result.added.length + ' products to your basket.', { href: root.dataset.cartUrl || '/cart', label: 'View basket' });
      }
      renderShelf(root);
      track('cp_b2c_products_added', { products: result.added.length, total_quantity: addedQty, failed: result.failed.length });
    } catch (error) {
      if (button) button.textContent = 'Check your basket';
      setStatus(root, 'We could not confirm the basket update. Check your basket before trying again to avoid adding the same items twice.', { href: root.dataset.cartUrl || '/cart', label: 'Check basket' });
      track('cp_b2c_cart_add_failed', { products: valid.length, reason: String(error && error.message || 'unknown').slice(0, 120) });
    } finally {
      window.setTimeout(function () {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      }, 2400);
    }
  }

  function renderShelf(root) {
    var target = qs('[data-b2cx-shelf-items]', root);
    if (!target) return;
    var store = memory();
    var saved = store ? store.saved().slice(0, 6) : [];
    if (!saved.length) {
      target.innerHTML = '<p class="cp-b2cx__empty">Nothing saved yet. Save a result to make it easy to find again.</p>';
      return;
    }
    target.innerHTML = saved.map(function (product) {
      var imageAlt = product.imageAlt || product.title || '';
      var image = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(imageAlt) + '" width="64" height="64" loading="lazy">' : '<span></span>';
      var savedPrice = product.price ? escapeHtml(product.price) + ' when saved · Check current product' : 'View current product';
      return '<article class="cp-b2cx__shelf-card">' + image + '<div><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a><small>' + savedPrice + '</small></div><button type="button" aria-label="Remove ' + escapeHtml(product.title) + ' from saved products" data-b2cx-remove="' + escapeHtml(product.handle) + '">×</button></article>';
    }).join('');
  }

  function showTool(root, key, moveFocus, updateHash) {
    var panels = qsa('[data-b2cx-panel]', root);
    var tabs = qsa('[data-b2cx-tab]', root);
    if (!panels.some(function (panel) { return panel.dataset.b2cxPanel === key; })) return;
    panels.forEach(function (panel) {
      var active = panel.dataset.b2cxPanel === key;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (active && moveFocus) window.setTimeout(function () { panel.focus({ preventScroll: true }); }, 0);
    });
    tabs.forEach(function (tab) {
      var active = tab.dataset.b2cxTab === key;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    root.dataset.activeTool = key;
    if (updateHash && history.replaceState && HASHES[key]) {
      history.replaceState(null, '', '#' + HASHES[key]);
    }
  }

  function initTabs(root) {
    var focusMap = { all: 'finder', finder: 'finder', coffee: 'coffee', taste: 'coffee', reorder: 'usage', cupboard: 'cupboard', setup: 'setup', water: 'water' };
    var hash = String(location.hash || '').replace('#', '');
    var hashKey = Object.keys(HASHES).find(function (key) { return HASHES[key] === hash; });
    var initial = hashKey || focusMap[root.dataset.focus || 'all'] || 'finder';
    showTool(root, initial, false, false);
    var tabs = qsa('[data-b2cx-tab]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        showTool(root, tab.dataset.b2cxTab, false, true);
        track('cp_b2c_tool_opened', { tool: tab.dataset.b2cxTab });
      });
      tab.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) < 0) return;
        event.preventDefault();
        var index = tabs.indexOf(tab);
        if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = tabs.length - 1;
        tabs[index].focus();
        tabs[index].click();
      });
    });
  }

  function scoreCoffee(product, preferences) {
    var text = productText(product);
    var score = 0;
    var reasons = [];
    function textMatch(pattern, points, reason) {
      if (pattern.test(text)) {
        score += points;
        if (reason && reasons.indexOf(reason) < 0) reasons.push(reason);
      }
    }
    if (preferences.serve === 'milk') {
      if (/excellent|good|strong/.test(String(product.milkSuitability || '').toLowerCase())) {
        score += 5;
        reasons.push('Its configured product data marks it as a good milk-drink option');
      } else textMatch(/milk drink|latte|cappuccino|through milk|versatile/, 2, 'The current product information connects it with milk drinks or versatility');
    } else {
      if (/excellent|good|strong/.test(String(product.blackSuitability || '').toLowerCase())) {
        score += 5;
        reasons.push('Its configured product data marks it as a good black-coffee option');
      } else textMatch(/black coffee|americano|filter|aromatic/, 2, 'The current product information connects it with black coffee or aromatic character');
    }
    if (preferences.direction === 'smooth') textMatch(/smooth|balanced|approachable|easy|versatile/, 3, 'Its current description leans smooth, balanced or versatile');
    else textMatch(/distinctive|character|aromatic|complex|lively/, 3, 'Its current description leans more distinctive or aromatic');
    if (preferences.flavour === 'chocolate') textMatch(/chocolate|cocoa|nut|caramel/, 3, 'Its current product information mentions the flavour direction you chose');
    else textMatch(/fruit|floral|berry|citrus/, 3, 'Its current product information mentions the flavour direction you chose');
    var acidity = safeNumber(product.acidity, 0);
    if (acidity) {
      if (preferences.acidity === 'soft' && acidity <= 3) { score += 3; reasons.push('Its configured acidity is on the softer side'); }
      if (preferences.acidity === 'bright' && acidity >= 3) { score += 3; reasons.push('Its configured acidity is on the brighter side'); }
    }
    if (preferences.role === 'everyday') textMatch(/everyday|versatile|approachable|balanced|familiar/, 2, 'Its current description suits an everyday role');
    else textMatch(/distinctive|single origin|character|aromatic|explor/, 2, 'Its current description suits a more exploratory choice');
    var intensity = safeNumber(product.intensity, 0);
    if (intensity) {
      if (preferences.strength === 'strong' && intensity >= 4) { score += 3; reasons.push('It has a stronger intensity'); }
      if (preferences.strength === 'balanced' && intensity <= 4) { score += 2; reasons.push('Its configured intensity is more balanced'); }
    } else if (preferences.strength === 'strong') textMatch(/strong|bold|intense|full bod/, 2, 'Its current description signals a stronger direction');
    return { product: product, score: score, reasons: reasons };
  }

  function rankedCoffee(products, preferences) {
    return productsBySubtype(products, 'coffee-beans').map(function (product, index) {
      var result = scoreCoffee(product, preferences);
      result.order = index;
      return result;
    }).sort(function (left, right) {
      return Number(right.product.available) - Number(left.product.available) || right.score - left.score || left.order - right.order;
    });
  }

  function initFinder(root, products) {
    var form = qs('[data-b2cx-finder]', root);
    var output = qs('[data-b2cx-finder-result]', root);
    if (!form || !output) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var drink = data.get('drink');
      var style = data.get('style');
      var milk = data.get('milk');
      if (drink === 'water') {
        output.hidden = false;
        output.innerHTML = '<div class="cp-b2cx__route-result"><p class="cp-b2cx__result-label">Best next step</p><h4>Start with the water question.</h4><p>Use the home Water Check to separate taste or scale concerns from a bigger plumbed-in convenience change. This browser cannot test your water.</p><div class="cp-b2cx__result-actions"><button type="button" class="is-primary" data-b2cx-open="water">Open Water Check</button><a href="/pages/home-solutions">Explore home water</a></div></div>';
        output.dataset.shareText = 'My Café Perfection starting point: check the home water route before choosing equipment.';
        track('cp_drink_finder_completed', { drink: drink, result: 'water-check' });
        return;
      }
      var candidates = [];
      if (drink === 'coffee') {
        if (style === 'fast') candidates = productsBySubtype(products, 'instant');
        else candidates = rankedCoffee(products, { serve: milk === 'black' ? 'black' : 'milk', direction: style === 'character' ? 'distinctive' : 'smooth', flavour: style === 'character' ? 'fruit' : 'chocolate', acidity: style === 'character' ? 'bright' : 'soft', role: 'everyday', strength: milk === 'milk' ? 'strong' : 'balanced' }).map(function (item) { return item.product; });
      } else if (drink === 'chocolate') {
        candidates = productsBySubtype(products, ['chocolate', 'white-chocolate']).sort(function (left, right) {
          var leftText = productText(left);
          var rightText = productText(right);
          var pattern = style === 'treat' ? /rich|belgian|indulgent|cocoa/ : /smooth|white|creamy/;
          return Number(pattern.test(rightText)) - Number(pattern.test(leftText));
        });
      } else if (drink === 'matcha') candidates = productsBySubtype(products, 'matcha');
      else if (drink === 'tea') candidates = productsBySubtype(products, 'tea');
      var best = candidates.find(function (product) { return product.available; }) || candidates[0] || null;
      var alternative = candidates.filter(function (product) { return best && product.handle !== best.handle; })[0] || null;
      output.hidden = false;
      if (!best) {
        output.innerHTML = '<div class="cp-b2cx__no-match"><strong>No current product match is available.</strong><p>Nothing is being invented to fill the gap. Browse the live range or ask Café Perfection for help.</p><div class="cp-b2cx__result-actions"><a class="is-primary" href="/collections/ingredients">Browse home drinks</a><a href="/pages/contact-us?intent=home-advice">Ask for help</a></div></div>';
      } else {
        var why = 'Closest current catalogue match to the preferences you selected. ' + shortText(best.profile || best.description, 30);
        output.innerHTML = '<div class="cp-b2cx__match-grid">' + productCard(best, why, { label: 'Your starting point', share: true }) + (alternative ? productCard(alternative, shortText(alternative.profile || alternative.description, 25), { label: 'Also consider' }) : '') + '</div>';
        output.dataset.shareText = 'My Café Perfection Drink Finder result: ' + best.title + '. ' + why;
      }
      track('cp_drink_finder_completed', { drink: drink, style: style, result: best ? best.handle : 'none' });
    });
  }

  function initCoffeeMatch(root, products) {
    var form = qs('[data-b2cx-coffee]', root);
    var output = qs('[data-b2cx-coffee-result]', root);
    if (!form || !output) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var preferences = {
        serve: data.get('serve'),
        direction: data.get('direction'),
        flavour: data.get('flavour'),
        acidity: data.get('acidity'),
        role: data.get('role'),
        strength: data.get('strength')
      };
      var ranked = rankedCoffee(products, preferences);
      var best = ranked[0] || null;
      var alternative = ranked[1] || null;
      output.hidden = false;
      if (!best) {
        output.innerHTML = '<div class="cp-b2cx__no-match"><strong>Coffee Match needs a current coffee product.</strong><p>No real coffee product is available in the loaded collections, so no match has been claimed.</p><div class="cp-b2cx__result-actions"><a class="is-primary" href="/collections/coffee-beans-auto">Browse coffee</a></div></div>';
      } else {
        var explanation = best.reasons.length ? best.reasons.slice(0, 3).join('. ') + '.' : 'This is the nearest current catalogue option. Open the product page to check the full, current tasting notes.';
        var alternativeText = alternative ? (alternative.reasons.length ? alternative.reasons.slice(0, 2).join('. ') + '.' : 'A legitimate second current coffee when you want a different direction.') : '';
        output.innerHTML = '<div class="cp-b2cx__match-grid">' + productCard(best.product, explanation, { label: 'Your best match', share: true }) + (alternative ? productCard(alternative.product, alternativeText, { label: 'Also try' }) : '') + '</div><p class="cp-b2cx__fine">Recommendations are guidance from current product information and confirmed taste detail—not a promise that everyone will taste the same thing.</p>';
        output.dataset.shareText = 'My Café Perfection Coffee Match: ' + best.product.title + '. ' + explanation;
      }
      track('cp_coffee_match_completed', { result: best ? best.product.handle : 'none', alternatives: alternative ? 1 : 0 });
    });
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function quantityProducts(products) {
    return products.filter(function (product) {
      return (product.pack > 0 || product.servings > 0) && ['coffee-beans', 'instant', 'chocolate', 'white-chocolate', 'matcha', 'milk', 'tea'].indexOf(product.subtype) > -1;
    });
  }

  function initUsage(root, products) {
    var form = qs('[data-b2cx-usage]', root);
    var select = qs('[data-b2cx-usage-product]', root);
    var doseInput = qs('[data-b2cx-dose]', root);
    var doseUnit = qs('[data-b2cx-dose-unit]', root);
    var packSource = qs('[data-b2cx-pack-source]', root);
    var output = qs('[data-b2cx-usage-result]', root);
    if (!form || !select || !output) return;
    var usable = quantityProducts(products);
    select.innerHTML = '';
    usable.forEach(function (product) {
      var option = document.createElement('option');
      option.value = product.handle;
      option.textContent = product.title + (product.price ? ' · ' + product.price : '');
      select.appendChild(option);
    });
    if (!usable.length) {
      form.hidden = true;
      output.innerHTML = '<div class="cp-b2cx__no-match"><strong>Quantity planning needs pack data.</strong><p>We do not yet have enough pack-size information to calculate this product safely. Check the product page or ask Café Perfection for help.</p><div class="cp-b2cx__result-actions"><a class="is-primary" href="/collections/ingredients">Shop current products</a></div></div>';
      return;
    }
    function syncProduct() {
      var product = byHandle(products, select.value);
      if (!product) return;
      doseInput.value = product.dose || '';
      doseInput.disabled = product.pack <= 0 && product.servings > 0;
      var doseLabel = product.doseUnit === 'bag' ? 'bag per drink' : (product.doseUnit ? product.doseUnit + ' per drink' : 'units per drink');
      doseUnit.textContent = doseInput.disabled ? 'Servings per pack will be used.' : doseLabel + (product.doseSource === 'metafield' ? ' · product information' : ' · enter the verified pack, recipe or setup dose');
      packSource.textContent = product.servings > 0 && !product.pack ? 'Servings per pack from the product information.' : (product.packSource === 'metafield' ? 'Pack size from the product information.' : 'Check the pack size on the product page before ordering.');
    }
    function calculate(shouldTrack) {
      output.hidden = false;
      var invalid = qsa('input,select', form).find(function (input) {
        return !input.disabled && (!input.checkValidity() || (input.type === 'number' && input.name !== 'dose' && input.value === ''));
      });
      if (invalid) {
        output.textContent = root.dataset.invalidQuantity || 'Check the entered figures before calculating your quantity. No buying quantity has been suggested.';
        if (shouldTrack) { invalid.focus(); invalid.reportValidity(); }
        return;
      }
      var product = byHandle(products, select.value);
      if (!product) return;
      var people = Number(form.elements.people.value);
      var drinks = Number(form.elements.drinks.value);
      var days = Number(form.elements.days.value);
      if (drinks === 0) {
        output.textContent = root.dataset.zeroQuantity || 'No drinks are planned at the current usage: 0 packs needed. No restock date or buying quantity has been suggested.';
        return;
      }
      var enteredDose = safeNumber(doseInput.value, 0);
      if (enteredDose <= 0 && product.servings <= 0) {
        output.innerHTML = '<div class="cp-b2cx__no-match"><strong>Enter the dose you actually use.</strong><p>Take it from the current pack, an approved recipe or the equipment setup. The calculator will not invent a product dose.</p></div>';
        return;
      }
      var buffer = Number(form.elements.buffer.value);
      var weeklyDrinks = people * drinks * days;
      var monthlyDrinks = weeklyDrinks * 52 / 12;
      var dose = enteredDose > 0 ? enteredDose : 0;
      var usesDose = dose > 0 && product.pack > 0;
      var servings = servingsFor(product,dose);
      if (!Number.isFinite(servings) || servings <= 0) {
        output.innerHTML = '<div class="cp-b2cx__no-match"><strong>Check this product’s pack information.</strong><p>The current data does not produce a reliable servings-per-pack figure, so no buying quantity has been suggested.</p><div class="cp-b2cx__result-actions"><a class="is-primary" href="' + escapeHtml(product.url) + '">Open product details</a></div></div>';
        return;
      }
      var monthlyUnits = usesDose ? monthlyDrinks * quantityUnit(dose,product.doseUnit||product.packUnit).value : monthlyDrinks;
      var rawMonthlyPacks = monthlyDrinks / servings;
      var bufferedMonthlyPacks = rawMonthlyPacks * buffer;
      var packs = Math.max(1, Math.ceil(bufferedMonthlyPacks));
      var onePackWeeks = servings / Math.max(weeklyDrinks, 0.01);
      var unit = usesDose ? (product.packUnit === 'bag' ? 'tea bags' : product.packUnit || 'units') : 'drinks';
      var spend = product.priceCents ? formatMoney(product.priceCents * packs) : 'See current price';
      var coverage = formatCoverage(onePackWeeks);
      var usageBand = Math.round(weeklyDrinks)+' drinks per week';
      var advice = '';
      var reorder = '';
      if (onePackWeeks >= 12) {
        advice = 'Your current use is light relative to this pack. One pack already gives long coverage, so buying several at once would usually create unnecessary stock.';
        reorder = 'Check stock again in roughly ' + Math.max(2, Math.round(onePackWeeks - Math.min(4, onePackWeeks * 0.15))) + ' weeks rather than treating this as a monthly order.';
        packs = 1;
        spend = product.priceCents ? formatMoney(product.priceCents) : 'See current price';
      } else if (onePackWeeks >= 4) {
        advice = 'One pack covers roughly a month or more at the usage entered. Start with one and use actual consumption to set the next reorder date.';
        reorder = 'A sensible first review point is around ' + Math.max(2, Math.round(onePackWeeks * 0.8)) + ' weeks, leaving a small safety margin.';
        packs = Math.max(1, Math.ceil(bufferedMonthlyPacks));
        spend = product.priceCents ? formatMoney(product.priceCents * packs) : 'See current price';
      } else if (onePackWeeks >= 2) {
        advice = 'This is regular usage. The suggested quantity is designed to cover about a month with the buffer you selected without building excessive stock.';
        reorder = 'Review the next order after about ' + Math.max(1, Math.round(onePackWeeks * Math.max(1, packs) * 0.8)) + ' weeks, then adjust from real use.';
      } else {
        advice = 'This is comparatively heavy usage for the selected pack. Keep an eye on peak weeks and storage space; a larger pack or a repeat-order routine may be more practical if one exists.';
        reorder = 'Check stock at least weekly until you have a reliable usage pattern.';
      }
      var collectionUrl = collectionForSubtype(product.subtype);
      var bufferText = Math.round((buffer - 1) * 100);
      output.innerHTML = '<div class="cp-b2cx__metric-grid"><div><span>Monthly use</span><strong>' + escapeHtml(Math.round(monthlyUnits).toLocaleString() + ' ' + unit) + '</strong></div><div><span>Suggested quantity</span><strong>' + packs + ' pack' + (packs === 1 ? '' : 's') + '</strong></div><div><span>One pack lasts</span><strong>' + escapeHtml(coverage) + '</strong></div><div><span>Approx. product spend</span><strong>' + escapeHtml(spend) + '</strong></div></div>' +
        '<div class="cp-b2cx__planning-advice"><span>' + escapeHtml(usageBand) + '</span><strong>' + escapeHtml(advice) + '</strong><p>' + escapeHtml(reorder) + '</p></div>' +
        '<p>Planning estimate: about ' + Math.round(servings) + ' drinks per pack ' + (usesDose ? 'at '+dose+' '+escapeHtml(product.doseUnit||product.packUnit)+' per drink' : 'using the stated servings per pack') + ', based on ' + days + ' drinking day' + (days === 1 ? '' : 's') + ' each week and a ' + bufferText + '% stock buffer. Use the current pack/recipe or equipment dose; this is not a preparation instruction or delivery promise.</p>' +
        '<div class="cp-b2cx__result-actions"><a href="' + escapeHtml(product.url) + '">Check product details</a><a href="' + escapeHtml(collectionUrl) + '">Compare this range</a><a href="/pages/ingredient-subscriptions">Plan repeat ordering</a>' + (product.available && product.variant ? '<button type="button" class="is-primary" data-b2cx-add-quantity="' + packs + '" data-handle="' + escapeHtml(product.handle) + '">Add suggested quantity</button>' : '') + '<button type="button" data-b2cx-save="' + escapeHtml(product.handle) + '">Save on this device</button></div>';
      if (shouldTrack) track('cp_usage_calculator_completed', { product: product.handle, packs: packs, days_per_week: days, usage_band: usageBand.toLowerCase().replace(/ /g, '_') });
    }
    invalidateResult(form, output, root.dataset.quantityChanged || 'Your figures changed. Calculate your quantity again before using a buying suggestion.');
    select.addEventListener('change' , syncProduct);
    form.addEventListener('submit', function (event) { event.preventDefault(); calculate(true); });
    root.addEventListener('cp:home-inputs-restored', function () { syncProduct(); calculate(false); });
    syncProduct();
    calculate(false);
  }

  function cupboardRole(subtype) {
    return {
      'coffee-beans': 'Whole-bean coffee for a compatible grinder or machine',
      instant: 'Fast soluble coffee route',
      chocolate: 'Café-style hot chocolate option',
      'white-chocolate': 'Sweeter chocolate alternative',
      matcha: 'Hot or iced matcha option',
      tea: 'Everyday tea option',
      milk: 'Only for a compatible powder recipe or system',
      extras: 'Useful drinks-station extra'
    }[subtype] || 'Selected current product';
  }

  var cupboardKeys={'coffee-beans':'coffee',instant:'instant',chocolate:'chocolate','white-chocolate':'whiteChocolate',matcha:'matcha',tea:'tea',milk:'milk',extras:'extras'};
  function saveCupboard(root){
    var form=qs('[data-b2cx-cupboard]',root),values={};if(!form||!window.CafeContext)return;
    qsa('input[type="checkbox"]',form).forEach(input=>{var key=cupboardKeys[input.value];if(key)values[key]=input.checked?'yes':'no';});
    values.items=(root.cpCupboardItems||[]).map(p=>({productId:String(p.id||''),variantId:String(p.variant||p.variantId||''),handle:p.handle,quantity:1}));
    var saved=window.CafeContext.saveTool('home_cupboard',values);root.cpCupboardSaved=!!saved.ok;
  }
  function renderCupboard(root, products, output) {
    var chosen = root.cpCupboardItems || [];
    var wanted=qsa('input[type="checkbox"]:checked',qs('[data-b2cx-cupboard]',root)),missing=wanted.filter(input=>!firstAvailable(products,input.value)).map(input=>({ 'coffee-beans':'whole-bean coffee',instant:'instant coffee',chocolate:'hot chocolate','white-chocolate':'white chocolate',matcha:'matcha',tea:'tea',milk:'milk powder / topping',extras:'approved household extras' }[input.value]||'selected category'));
    var missingMessage=missing.length?'<p role="status">No currently available option for '+escapeHtml(missing.join(', '))+'. These choices are not included. Review the products shown before adding your cupboard.</p>':'';
    if (!chosen.length) {
      output.hidden = false;
      output.innerHTML = missingMessage+'<div class="cp-b2cx__no-match"><strong>Your cupboard is empty.</strong><p>Choose at least one drink above, then build it again.</p></div>';
      return;
    }
    var essentials = chosen.map(function (product) {
      return '<article><div><span>Essential for your choices</span><strong>' + escapeHtml(product.title) + '</strong><small>' + escapeHtml(cupboardRole(product.subtype)) + '</small></div><div><b>' + escapeHtml(product.price || '') + '</b><button type="button" data-b2cx-remove-selection="' + escapeHtml(product.handle) + '">Remove</button></div></article>';
    }).join('');
    var optional = [];
    var hasDrinkPowder = chosen.some(function (product) { return ['chocolate', 'white-chocolate', 'matcha', 'instant'].indexOf(product.subtype) > -1; });
    var milk = firstAvailable(products, 'milk');
    var extras = firstAvailable(products, 'extras');
    if (hasDrinkPowder && milk && !chosen.some(function (product) { return product.handle === milk.handle; })) optional.push(milk);
    if (extras && !chosen.some(function (product) { return product.handle === extras.handle; })) optional.push(extras);
    output.hidden = false;
    output.innerHTML = missingMessage+'<div class="cp-b2cx__cupboard"><section><h4>Essentials</h4><div class="cp-b2cx__selection">' + essentials + '</div></section>' + (optional.length ? '<section><h4>Optional extras</h4><p>Not included unless you choose them. Check compatibility and usefulness first.</p><div class="cp-b2cx__optional">' + optional.map(function (product) { return '<button type="button" data-b2cx-add-option="' + escapeHtml(product.handle) + '"><strong>' + escapeHtml(product.title) + '</strong><span>' + escapeHtml(cupboardRole(product.subtype)) + '</span><em>Add to my cupboard</em></button>'; }).join('') + '</div></section>' : '') + '</div><div class="cp-b2cx__result-actions"><button type="button" class="is-primary" data-b2cx-add-selection>Add cupboard to basket</button><span>' + chosen.length + ' product' + (chosen.length === 1 ? '' : 's') + ' selected · no discount implied</span></div>';
  }

  function cupboardNote(root,output){
    var note=document.createElement('p');note.className='cp-b2cx__note';note.setAttribute('role','status');
    note.textContent=(root.cpCupboardSaved?(window.CafeContext?.status().storage==='device'?'Saved on this device for up to 30 days. ':'Saved in this tab for up to two hours. '):'This cupboard has not been saved between pages. ')+ 'This is a shopping list, not past order history. Displayed prices and availability are from the current catalogue; check the basket before checkout.';
    output.append(note);
  }
  function initCupboard(root, products) {
    var form = qs('[data-b2cx-cupboard]', root);
    var output = qs('[data-b2cx-cupboard-result]', root);
    var starts = qs('[data-b2cx-easy-starts]', root);
    if (!form || !output) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var wanted = qsa('input[type="checkbox"]:checked', form).map(function (input) { return input.value; });
      var chosen = [];
      wanted.forEach(function (subtype) {
        var product = firstAvailable(products, subtype);
        if (product && !chosen.some(function (item) { return item.handle === product.handle; })) chosen.push(product);
      });
      root.cpCupboardItems = chosen;
      saveCupboard(root);renderCupboard(root, products, output);cupboardNote(root,output);
      track('cp_cupboard_generated', { selected_jobs: wanted.length, products: chosen.length });
    });
    invalidateResult(form, output, root.dataset.cupboardChanged || 'Your drink choices changed. Build the cupboard again to review current products.', function () {
      root.cpCupboardItems = [];
      saveCupboard(root);
    });
    function restoreCupboard() {
      root.cpCupboardItems = []; root.cpCupboardSaved = false;
      output.hidden = true; output.textContent = '';
      var stored=window.CafeContext?.readTool('home_cupboard');
      qsa('input[type="checkbox"]',form).forEach(input=>{var value=stored?.[cupboardKeys[input.value]];input.checked=value?value==='yes':input.defaultChecked;});
      if (!stored) return;
      var restored=[],issues=[];(stored.items||[]).forEach(ref=>{var p=products.find(x=>String(x.id)===ref.productId&&x.handle===ref.handle);if(!p||!p.available||String(p.variant||p.variantId||'')!==ref.variantId)issues.push(ref.handle);else restored.push(p);});
      if(issues.length){output.hidden=false;output.innerHTML='';var note=document.createElement('p');note.setAttribute('role','status');note.textContent='Your saved cupboard needs review: '+issues.join(', ')+'. A product, configuration or availability has changed. Your drink choices are restored; build the cupboard again to review current products. Nothing has been substituted or added.';output.append(note);}
      else if(!restored.length){output.hidden=false;output.textContent=root.dataset.cupboardRestored || 'Your drink choices are restored. Build the cupboard to review current products.';}
      else{root.cpCupboardItems=restored;root.cpCupboardSaved=true;renderCupboard(root,products,output);cupboardNote(root,output);}
    }
    restoreCupboard();
    root.addEventListener('cp:home-inputs-restored', restoreCupboard);
    var coffee = productsBySubtype(products, 'coffee-beans').filter(function (product) { return product.available; }).slice(0, 2);
    var chocolates = productsBySubtype(products, ['chocolate', 'white-chocolate']).filter(function (product) { return product.available; }).slice(0, 2);
    var household = [firstAvailable(products, 'coffee-beans'), firstAvailable(products, 'tea'), firstAvailable(products, 'chocolate')].filter(Boolean);
    var definitions = [
      { key: 'coffee', title: 'Coffee Explorer', copy: 'Two different current coffees in one basket shortcut.', products: coffee },
      { key: 'chocolate', title: 'Chocolate choices', copy: 'Two current chocolate directions to try side by side.', products: chocolates },
      { key: 'household', title: 'Household drinks shelf', copy: 'Coffee, tea and chocolate where all three are currently stocked.', products: household }
    ].filter(function (item) { return item.products.length > 1; });
    root.cpEasyStarts = {};
    definitions.forEach(function (item) { root.cpEasyStarts[item.key] = item.products; });
    if (starts && definitions.length) {
      starts.hidden = false;
      starts.innerHTML = '<div><p class="cp-b2cx__result-label">Easy starts</p><h4>Real products. One basket shortcut.</h4><p>These are convenience selections at current individual prices—not discounted bundles.</p></div><div>' + definitions.map(function (item) { return '<article><span>' + escapeHtml(item.title) + '</span><strong>' + escapeHtml(item.products.map(function (product) { return product.title; }).join(' + ')) + '</strong><p>' + escapeHtml(item.copy) + '</p><button type="button" data-b2cx-add-easy="' + escapeHtml(item.key) + '">Add these products</button></article>'; }).join('') + '</div>';
    }
  }

  function setupCoffee(products, preference) {
    var ranked = rankedCoffee(products, preference);
    var available = ranked.find(function (item) { return item.product.available; });
    return available ? available.product : firstAvailable(products, 'coffee-beans');
  }

  function initSetup(root, products) {
    var form = qs('[data-b2cx-setup]', root);
    var output = qs('[data-b2cx-setup-result]', root);
    if (!form || !output) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var brew = data.get('brew');
      var grinder = data.get('grinder');
      var milk = data.get('milk');
      var priority = data.get('priority');
      var product = null;
      var title = '';
      var explanation = '';
      var actions = '';
      if (brew === 'pod') {
        title = 'Keep the pod route unless you want a separate brewer.';
        explanation = 'Whole beans are not a direct fit for a pod-only machine. Café Perfection should not force a bean sale when your current equipment cannot use it.';
        actions = '<a class="is-primary" href="/pages/home-solutions">Explore setup options</a>';
      } else if (brew === 'instant') {
        product = firstAvailable(products, 'instant');
        title = product ? 'Instant coffee suits the setup you described.' : 'We could not find a matching product. Ask us for help choosing.';
        explanation = product ? 'You selected instant preparation, so start with an instant coffee product and follow its preparation instructions.' : 'Browse the current range or ask before substituting another format.';
      } else if (brew === 'bean') {
        if (grinder === 'no' || grinder === 'unsure') {
          title = 'Whole beans need a suitable grinder.';
          explanation = 'Your selected machine route needs ground coffee, but a suitable grinder has not been confirmed. Check the equipment or choose a compatible pre-ground route before buying beans.';
          actions = '<a class="is-primary" href="/pages/home-solutions">Check the wider setup</a>';
        } else {
          product = setupCoffee(products, { serve: milk === 'rarely' ? 'black' : 'milk', direction: priority === 'variety' ? 'distinctive' : 'smooth', flavour: priority === 'variety' ? 'fruit' : 'chocolate', acidity: priority === 'variety' ? 'bright' : 'soft', role: priority === 'variety' ? 'explore' : 'everyday', strength: milk === 'often' ? 'strong' : 'balanced' });
          title = 'Your existing route can use whole beans.';
          explanation = 'You do not need a new machine to begin. Start with a sensible quantity of a current coffee, then adjust using the way it performs in your own setup.';
        }
      } else if (brew === 'manual') {
        if (grinder === 'no' || grinder === 'unsure') {
          title = 'Check the coffee format before ordering.';
          explanation = 'A manual brewer still needs coffee ground appropriately for that method. Whole beans are practical only if you have a suitable grinder; ask whether a compatible format is available.';
          actions = '<a class="is-primary" href="/pages/contact-us?intent=home-coffee-format">Ask about coffee format</a>';
        } else {
          product = setupCoffee(products, { serve: milk === 'rarely' ? 'black' : 'milk', direction: priority === 'variety' ? 'distinctive' : 'smooth', flavour: priority === 'variety' ? 'fruit' : 'chocolate', acidity: priority === 'variety' ? 'bright' : 'soft', role: 'everyday', strength: 'balanced' });
          title = 'Your manual setup can start with the coffee.';
          explanation = 'Use a grind and preparation method appropriate to your brewer. The product page and your brewer guidance remain the source of truth.';
        }
      } else {
        title = 'Choose the brewing route before the coffee format.';
        explanation = 'There is no honest product match until the preparation method is known. Begin with the setup guide or ask Café Perfection.';
        actions = '<a class="is-primary" href="/pages/home-solutions">Open the home setup guide</a><a href="/pages/contact-us?intent=home-advice">Ask for help</a>';
      }
      output.hidden = false;
      output.innerHTML = product ? '<div class="cp-b2cx__route-heading"><p class="cp-b2cx__result-label">Your practical starting point</p><h4>' + escapeHtml(title) + '</h4><p>' + escapeHtml(explanation) + '</p></div>' + productCard(product, shortText(product.profile || product.description, 30), { label: 'Current product to consider' }) : '<div class="cp-b2cx__route-result"><p class="cp-b2cx__result-label">Your practical starting point</p><h4>' + escapeHtml(title) + '</h4><p>' + escapeHtml(explanation) + '</p><div class="cp-b2cx__result-actions">' + actions + '</div></div>';
      track('cp_home_setup_completed', { brew: brew, result: product ? product.handle : 'guidance' });
    });
  }

  function initWater(root) {
    var form = qs('[data-b2cx-water]', root);
    var output = qs('[data-b2cx-water-result]', root);
    if (!form || !output) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var scale = data.get('scale');
      var taste = data.get('taste');
      var plumbed = data.get('plumbed');
      var outputs = data.get('outputs');
      var tenure = data.get('tenure');
      var title = '';
      var copy = '';
      var links = '';
      var route = '';
      if (outputs === 'yes' || plumbed === 'yes') {
        route = 'plumbed-check';
        title = 'A plumbed home-water route may be worth comparing.';
        copy = 'Chilled, sparkling or instant-hot convenience is a system and installation decision—not just a filter purchase. Confirm connection, pressure, drainage, power, space and exact output first.' + (tenure === 'rent' ? ' Because you rent, confirm permission before any permanent change.' : '');
        links = '<a class="is-primary" href="/pages/home-solutions">Explore home water</a><a href="/pages/contact-us?intent=home-water">Check installation</a>';
      } else if (scale === 'lots' || taste === 'yes') {
        route = 'filtration-check';
        title = 'Simple filtration may help—after compatibility is checked.';
        copy = 'You reported recurring scale or a noticeable taste/odour. That is a sensible reason to investigate filtration, but the filter must suit the appliance, connection and water requirement. This result is not a water test or health claim.';
        links = '<a class="is-primary" href="/collections/filters-auto">Browse current filters</a><a href="/pages/contact-us?intent=filter-compatibility">Check compatibility</a>';
      } else if (plumbed === 'maybe') {
        route = 'compare';
        title = 'Compare convenience with the work of installation.';
        copy = 'You have not flagged a strong water problem, but you are open to a plumbed route. Start with the outputs you value and the practical installation limits before choosing equipment.';
        links = '<a class="is-primary" href="/pages/home-solutions">Compare home routes</a>';
      } else {
        route = 'no-change';
        title = 'You may not need to change anything.';
        copy = 'Your answers do not show a strong scale, taste or convenience reason to add equipment. Keep the current setup simple and revisit only if there is a clear problem to solve.';
        links = '<a class="is-primary" href="/pages/coffee-knowledge-hub">Improve the drink another way</a><a href="/collections/filters-auto">See filters anyway</a>';
      }
      output.hidden = false;
      output.innerHTML = '<div class="cp-b2cx__route-result"><p class="cp-b2cx__result-label">Your water route</p><h4>' + escapeHtml(title) + '</h4><p>' + escapeHtml(copy) + '</p><div class="cp-b2cx__result-actions">' + links + '</div></div>';
      track('cp_home_water_completed', { route: route, tenure: tenure });
    });
  }

  function shareResult(button) {
    var result = button.closest('.cp-b2cx__result');
    var text = result && result.dataset.shareText ? result.dataset.shareText : 'My Café Perfection drinks result';
    if (navigator.share) {
      navigator.share({ title: 'Café Perfection', text: text, url: location.href }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(text + ' ' + location.href).then(function () {
        var original = button.textContent;
        button.textContent = 'Link copied ✓';
        window.setTimeout(function () { button.textContent = original; }, 1600);
      }).catch(function () {});
    }
  }

  function initDelegatedActions(root, products) {
    root.addEventListener('click', function (event) {
      var target = event.target.closest('button, a');
      if (!target) return;
      if (target.matches('[data-b2cx-open]')) {
        event.preventDefault();
        showTool(root, target.dataset.b2cxOpen, true, true);
        scrollToTool(qs('[data-b2cx-panel="' + target.dataset.b2cxOpen + '"]', root));
      } else if (target.matches('[data-b2cx-add-handle]')) {
        addItems(root, [byHandle(products, target.dataset.b2cxAddHandle)], target);
      } else if (target.matches('[data-b2cx-add-quantity]')) {
        addItems(root, [byHandle(products, target.dataset.handle)], target, [safeNumber(target.dataset.b2cxAddQuantity, 1)]);
        track('cp_reorder_quantity_selected', { product: target.dataset.handle, quantity: safeNumber(target.dataset.b2cxAddQuantity, 1) });
      } else if (target.matches('[data-b2cx-save]')) {
        var product = byHandle(products, target.dataset.b2cxSave);
        if (product) {
          saveProduct(root, product);
          target.textContent = 'Saved ✓';
        }
      } else if (target.matches('[data-b2cx-remove]')) {
        var store = memory();
        if (store) store.removeSaved(target.dataset.b2cxRemove);
        renderShelf(root);
      } else if (target.matches('[data-b2cx-remove-selection]')) {
        root.cpCupboardItems = (root.cpCupboardItems || []).filter(function (product) { return product.handle !== target.dataset.b2cxRemoveSelection; });
        saveCupboard(root);renderCupboard(root, products, qs('[data-b2cx-cupboard-result]', root));cupboardNote(root,qs('[data-b2cx-cupboard-result]',root));
      } else if (target.matches('[data-b2cx-add-option]')) {
        var optional = byHandle(products, target.dataset.b2cxAddOption);
        if (optional && !(root.cpCupboardItems || []).some(function (product) { return product.handle === optional.handle; })) {
          root.cpCupboardItems = (root.cpCupboardItems || []).concat(optional);
          saveCupboard(root);renderCupboard(root, products, qs('[data-b2cx-cupboard-result]', root));cupboardNote(root,qs('[data-b2cx-cupboard-result]',root));
        }
      } else if (target.matches('[data-b2cx-add-selection]')) {
        addItems(root, root.cpCupboardItems || [], target);
        track('cp_cupboard_added', { products: (root.cpCupboardItems || []).length });
      } else if (target.matches('[data-b2cx-add-easy]')) {
        addItems(root, (root.cpEasyStarts && root.cpEasyStarts[target.dataset.b2cxAddEasy]) || [], target);
      } else if (target.matches('[data-b2cx-share-result]')) {
        shareResult(target);
      }
    });
  }

  function initExternalLaunchers() {
    if (document.documentElement.dataset.cpB2cLaunchers === '1') return;
    document.documentElement.dataset.cpB2cLaunchers = '1';
    document.addEventListener('click', function (event) {
      var launcher = event.target.closest('[data-b2c-open-tool]');
      if (!launcher) return;
      var root = qs('[data-cp-b2cx]');
      if (!root) return;
      event.preventDefault();
      var tool = launcher.dataset.b2cOpenTool || 'finder';
      showTool(root, tool, false, true);
      if (launcher.dataset.drink) {
        var input = qs('[data-b2cx-finder] input[name="drink"][value="' + launcher.dataset.drink + '"]', root);
        if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      scrollToTool(root);
      var panel = qs('[data-b2cx-panel="' + tool + '"]', root);
      if (panel) panel.focus({ preventScroll: true });
      track('cp_b2c_tool_opened', { tool: tool, source: launcher.dataset.b2cSource || 'page' });
    });
  }

  function init(root) {
    if (window.CPCatalogue && !root.dataset.catalogueReady) {
      if (root.dataset.catalogueWaiting) return;
      root.dataset.catalogueWaiting = '1';
      window.CPCatalogue.connect(root, function(items) {
        var data = root.querySelector('[data-cp-b2cx-products]');
        if (data) data.textContent = JSON.stringify(items.filter(function(p){ return p.enabled !== false && (p.category === 'ingredient' || p.category === 'accessory' || p.scope === 'home' || p.scope === 'both'); }));
        root.dataset.catalogueReady = '1'; delete root.dataset.catalogueWaiting; init(root);
      }, function(){ delete root.dataset.catalogueWaiting; });
      return;
    }
    if (!root || root.dataset.b2cxReady === '1') return;
    root.dataset.b2cxReady = '1';
    var products = parseProducts(root);
    initTabs(root);
    initFinder(root, products);
    initCoffeeMatch(root, products);
    initUsage(root, products);
    initCupboard(root, products);
    initSetup(root, products);
    initWater(root);
    initResultRecovery(root);
    initDelegatedActions(root, products);
    renderShelf(root);
    var refreshShelf = function () { if (root.isConnected) renderShelf(root); };
    document.addEventListener('cp:memory:change', refreshShelf);
    root.cpB2cxCleanup = function () { document.removeEventListener('cp:memory:change', refreshShelf); };
  }

  function initAll(scope) {
    if (scope && scope.matches && scope.matches('[data-cp-b2cx]')) init(scope);
    qsa('[data-cp-b2cx]', scope || document).forEach(init);
    initExternalLaunchers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = qsa('[data-cp-b2cx]', event.target);
    if (event.target.matches('[data-cp-b2cx]')) roots.push(event.target);
    roots.forEach(function (root) { if (root.cpB2cxCleanup) root.cpB2cxCleanup(); });
  });
})();
